import React from 'react';
import { Section } from './ui/Section';
export function EmotionalIntro() {
  return <Section className="bg-white" data-id="element-1">
      <div className="text-center max-w-3xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D2D2D] mb-8" data-id="element-3">
          Hay un punto donde ya no te falta amor propio.
        </h2>

        <p className="text-lg md:text-xl text-[#666666] mb-8 leading-relaxed" data-id="element-4">
          Te falta un plan que te impida volver a elegir al mismo hombre con
          distinta cara.
        </p>

        <div className="bg-[#FAF8F5] p-8 rounded-2xl border-l-4 border-[#D4735E] text-left my-10" data-id="element-5">
          <p className="text-lg font-medium text-[#2D2D2D] mb-4" data-id="element-6">
            Porque eso es lo que pasa cuando “aprendes la lección” y aun así:
          </p>
          <ul className="space-y-3" data-id="element-7">
            {['Te ghostean', 'Te engañan', 'Te usan solo para sexo', 'Nunca te presentan a su familia', 'Nunca formalizan'].map((item, index) => <li key={index} className="flex items-center text-[#666666]" data-id="element-8">
                <span className="w-1.5 h-1.5 bg-[#D4735E] rounded-full mr-3" data-id="element-9" />
                {item}
              </li>)}
          </ul>
        </div>

        <p className="text-xl md:text-2xl font-serif italic text-[#2D2D2D]" data-id="element-10">
          No porque tengas mala vibra.
          <br data-id="element-11" />
          <span className="text-[#D4735E] not-italic font-bold mt-2 block" data-id="element-12">
            Sino porque tu sistema de elección está roto.
          </span>
        </p>
      </div>
    </Section>;
}